import {
    booleanAttribute,
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    input,
    Output,
    ViewEncapsulation,
} from '@angular/core';

@Component({
    selector: 'ui-m000-c020-dialog-wrapper',
    standalone: true,
    templateUrl: './m000-c020-dialog-wrapper.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [],
})
export class M000C020DialogWrapperComponent {
    outsideClick = input(true, { transform: booleanAttribute });
    blur = input(false, { transform: booleanAttribute });
    blackOpacityPercentage = input<30 | 40 | 50 | 60 | 70 | 90>(30);

    @Output() clicked = new EventEmitter<void>();

    closeDialog(): void {
        if (this.outsideClick()) {
            this.clicked.emit();
        }
    }
}
